import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { doraReadPermission } from '@platform/plugin-platform-common';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { incidentRouteRef, rootRouteRef } from './routes';

/**
 * La liste des incidents et le détail d'un incident, extraits de
 * `legacyRoot.tsx` (phase 4c).
 *
 * Les deux routes rendent le MÊME composant, `IncidentsPage`, qui lit `:id`
 * par `useParams` : sans identifiant il affiche la liste, avec il affiche le
 * détail. Deux `PageBlueprint` plutôt qu'un seul, parce que c'est la seule
 * façon de donner à la page un paramètre `:id` que `useParams` voit — même
 * montage que `/ai-observability/traces/:traceId`.
 *
 * La permission est `doraReadPermission`, de `platform-common` : les incidents
 * sont une donnée DORA. C'est celle que portait la route legacy.
 *
 * Changement visible assumé (décision 9 de la spec) : l'entrée « Incidents »
 * n'est plus masquée aux utilisateurs sans `platform.dora.read`. Ils la
 * voient, et la page leur refuse l'accès.
 */
const loadIncidents = () =>
  import('./components/IncidentsPage').then(m => (
    <RequirePermission permission={doraReadPermission}>
      <m.IncidentsPage />
    </RequirePermission>
  ));

const incidentsPage = PageBlueprint.make({
  params: {
    path: '/incidents',
    routeRef: rootRouteRef,
    title: 'Incidents',
    icon: <ErrorOutlineIcon />,
    noHeader: true,
    loader: loadIncidents,
  },
});

// Pas d'`icon` : le détail n'a pas d'entrée de menu.
const incidentPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/incidents/:id',
    routeRef: incidentRouteRef,
    title: 'Incident',
    noHeader: true,
    loader: loadIncidents,
  },
});

export default createFrontendPlugin({
  pluginId: 'incidents',
  extensions: [incidentsPage, incidentPage],
});
